/* global System */
// register component(s) with react habitat

export default {
  Team: () => System.import('./index'),
}
